import * as React from "react";
function SvgList(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={svgRef}
      {...props}
    >
      <path d="M0 0h12v12H0V0zm16 0h32v12H16V0zM0 18h12v12H0V18zm16 0h32v12H16V18zM0 36h12v12H0V36zm16 0h32v12H16V36z" />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgList);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
